import { render } from "./ChangeWorkloadPreparation.vue?vue&type=template&id=a5de688c"
import script from "./ChangeWorkloadPreparation.vue?vue&type=script&lang=js"
export * from "./ChangeWorkloadPreparation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__